import { Input } from '@trackman/web-shared-components';
import { observer } from 'mobx-react-lite';
import { useStores } from 'index';

export const EventTitleInput = observer(() => {
  const es = useStores().trackmanEventsEditorStore;

  return (
    <div className='admin-edit-section'>
      <h2>Title*</h2>
      <div className='input-wrapper'>
        <Input
          label='Title'
          hint='Max. 80 characters'
          value={es.eventItem.title ?? ''} //we only support one title for now
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            if (e.currentTarget.value.length > 80) return es.eventItem.title;
            es.eventItem.title = e.currentTarget.value;
          }}
        />
      </div>
    </div>
  );
});

export default EventTitleInput;
